import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {Styles} from "../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import {withRouter} from "react-router";
import 'shikwasa/dist/style.css';
import './player.css'
import { Player } from 'shikwasa';
import {Translate} from "../../../config/Translate";
import {defaultVariabls} from "../../../config";
import axios from "axios";
import Button from "@material-ui/core/Button/Button";

class PlayerPage extends React.Component {

    state = {
        episode:this.props.episode,
        book:this.props.book,
        player:null
    };
    classes = this.props.classes;
    async componentDidMount() {
        await this.setState({
            episode:this.props.episode,
            book:this.props.book,
        })
        await this.createPlayer();
        setInterval(() => this.checkIsFinished(),900);

    }
    async componentDidUpdate(prevProps){
        if(this.state.episode !== this.props.episode){
            await this.setState({
                episode:this.props.episode
            })

            await this.createPlayer();
        }

    }
    async componentWillUnmount() {
        await this.updateDB();
        await this.state.player.destroy();

    }
    async updateDB(){
        let elements = document.getElementsByClassName('shk-time_now')
        let current_time = elements[0].innerHTML;
        let {episode} = this.state;
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            let data = new FormData();
            data.append('episode_id', episode.id);
            data.append('current_time', current_time);
            await axios.post(`${defaultVariabls.url}/library/update-audiobook`,data, config)
                .then(response => {

                }).catch(error => {
                    console.log(error.response)
                })
        }
    }
    async createPlayer(){
        let {episode,book,player} = this.state;
        player = new Player({
            container: () => document.querySelector('#player'),
            fixed: {
                type: 'static',
                position: 'top',
            },
            audio: {
                title: !!episode.name ? episode.name : Translate.episode,
                cover:
                !!episode.thumbnail ?
                    `${defaultVariabls.uploads}/FileManager/${episode.thumbnail.name}_medium.${episode.thumbnail.extension}`:
                    `${defaultVariabls.uploads}/FileManager/${book.product.thumbnail.name}_book.${book.product.thumbnail.extension}`
                ,
                artist: book.product.name,
                src: `${defaultVariabls.website}/file/get-audio/${episode.file.id}?token=${episode.file.token}`,
                /*src:"https://rayanita.com/gftam_ghame_to.mp3"*/
            },
            themeColor:"#e4a438"
        })
        await this.setState({
            player
        })
        setTimeout(() => {
            this.handleSeek();
            this.state.player.play();
        }, 1000);
    }
    handleSeek(){
        let {book,episode} = this.state;
        if(book.current_chapter === episode.id && !!book.current_time){
            this.state.player.seek(book.current_time)
        }

    }
    checkIsFinished(){
        let {player} = this.state;
        if(!!player){
            if(parseInt(player.currentTime) === parseInt(player.duration)){
                this.props.handleNextTrack();
            }
        }

    }
    render(){
        let {episode} = this.state;
        return (
            <>
                <div id="player"></div>
            </>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(PlayerPage))));